function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "send_svg__cls-1",
  d: "M19 .79l-2.71 16.29a.68.68 0 01-.34.48.69.69 0 01-.33.08.74.74 0 01-.25-.05l-4.8-2L8 18.76a.66.66 0 01-.52.24.62.62 0 01-.23 0 .68.68 0 01-.45-.64v-3.7l9.16-11.23-11.34 9.81-4.19-1.72a.67.67 0 01-.42-.58.68.68 0 01.34-.62L18 .09a.66.66 0 01.34-.1.68.68 0 01.38.12.69.69 0 01.28.68z"
});

var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 19 19"
  }, props), _ref);
};

export default SvgSend;